import type { IEmploymentPractitioner } from '../../components/pages/personalSettings/personalSettingsGeneralSettings/PersonalSettingsGeneralSettings';
import { hasValidAgbCode } from '../../../common/utils/hasValidAgbCode';
import { fetchJson } from '../../store/fetch';

export async function getSupervisors(organizationId: string, excludePractitionerId?: string) {
    const url = `/api/employments/${organizationId}/practitioners?isActive=true`;
    const result = await fetchJson(url, 'GET');

    return (result.json.items as IEmploymentPractitioner[]).filter(
        (employmentPractitioner) =>
            employmentPractitioner.practitionerId !== excludePractitionerId &&
            hasValidAgbCode(employmentPractitioner.practitioner)
    );
}
